import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

import styled from '@emotion/styled'

import {
  FocusSpan,
  underlineFocus,
} from 'portal-modules/common/components/focus-styles'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()

const StyledLi = styled('li')`
  .tabs--header & {
    flex: 0 0 auto;
    padding: 0 4px;
  }
  :first-of-type a {
    border-radius: ${({ theme }) => theme.mode.card_border_radius} 0 0 ${({ theme }) => theme.mode.card_border_radius};
  }
  :last-of-type a {
    border-radius: 0 ${({ theme }) => theme.mode.card_border_radius} ${({ theme }) => theme.mode.card_border_radius} 0;
  }
  .tabs--content & {
    display: inline-block;

    :not(:last-child) a {
      border-right: none;
    }
  }
`

const StyledLink = styled(NavLink)`
  display: block;
  font-size: 12px;
  outline: none;
  text-decoration: none;

  .tabs--header & {
    padding: 0 16px 8px;
    color: ${({ theme }) =>
      getEmbeddedViewFlag()
        ? theme.secondary.base
        : isRP
        ? theme.gray.gray4
        : theme.mode.tab_active_text_color};

    @media only screen and (max-width: 500px) {
      padding: ${props => (props.removePad ? `16px 4px 8px` : `16px 8px 16px`)};
    }

    &.active {
      position: relative;
      font-weight: bold;
      color: ${({ theme }) =>
        getEmbeddedViewFlag()
          ? theme.button_primary.background
          : isRP
          ? theme.gray.gray4
          : theme.mode.tab_active_text_color};

      ::after {
        background: ${({ theme }) =>
          getEmbeddedViewFlag()
            ? theme.button_primary.background
            : theme.reskinMenu.active_color};
        bottom: 0;
        content: '';
        display: block;
        height: 4px;
        left: 12px;
        position: absolute;
        right: 12px;
        @media only screen and (max-width: 500px) {
          left: 4px;
          right: 4px;
          height: 2px;
        }
      }
    }
  }

  .tabs--content & {
    background: ${({ theme }) => theme.mode.isDark ? 'transparent' : theme.gray.highlight};
    border: 1px solid ${({ theme }) => theme.gray.light};
    color: ${({ theme }) => theme.gray.base};
    padding: 4px 16px;

    &.active {
      background: ${({ theme }) =>
        getEmbeddedViewFlag()
          ? theme.button_primary.background
          : 'transparent'};
      color: ${({ theme }) =>
        getEmbeddedViewFlag() 
        ? theme.embedded.button_text 
        : theme.mode.isDark
          ? theme.fields.focus
          :theme.gray.gray4};
    }
  }

  &.active {
    font-weight: bold;
  }

  &:not(.active) {
    ${underlineFocus};
  }
`

const TabNavItem = ({ children, to, ...rest }) => (
  <StyledLi>
    <StyledLink to={to} {...rest}>
      <FocusSpan>{children}</FocusSpan>
    </StyledLink>
  </StyledLi>
)

TabNavItem.propTypes = {
  children: PropTypes.any.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
}

export default TabNavItem
